<template>
  <div id="app">
    <router-view/>
<!-- 	
	http://smart_clothing_h5.30days-tech.com/#/proxy 协议
	http://smart_clothing_h5.30days-tech.com/#/privacy 隐私
	http://smart_clothing_h5.30days-tech.com/#/loadDown //下载地址
	http://smart_clothing_h5.30days-tech.com/#/productDetail?deviceId=1&accessToken= //产品详情
	http://smart_clothing_h5.30days-tech.com/#/equipmentUse?deviceId=1 //使用说明

	-->
  </div>
</template>
<script>
	export default({
		data(){
			return {
				userName:''
			}
		},
		created() {
			if(this.$route.query.accessToken){
				localStorage.setItem('accessToken',this.$route.query.accessToken)
			}
		}
	})
</script>
<style>
	.disable{
		display: none;
	}
	.t44{
		/* margin-top: 44px; */
	}
	*{
		box-sizing: border-box;
	}
	.disable{
        display: none;
    }
</style>
